import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export interface ExternalProps {
  rows: any;
}

export const WageringHistoryTable = (props: ExternalProps) => {
  const classes = useStyles();
  const { rows } = props;

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Ticket</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Free Play</TableCell>
            <TableCell>Risk</TableCell>
            <TableCell>To Win</TableCell>
            <TableCell>Result</TableCell>
            <TableCell>Contribution %</TableCell>
            <TableCell>Contribution Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows &&
            rows.length > 0 &&
            rows.map((row: any) => (
              <TableRow key={row.ticket}>
                <TableCell component='th' scope='row'>
                  {new Date(row.timestamp).toLocaleString('en-US', {
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                  })}
                </TableCell>
                <TableCell>{row.ticket}</TableCell>
                <TableCell>{row.type}</TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell>{row.freePlay ? 'Yes' : 'No'}</TableCell>
                <TableCell>{row.risk}</TableCell>
                <TableCell>{row.toWin}</TableCell>
                <TableCell>{row.result}</TableCell>
                <TableCell>{row.cPercent}</TableCell>
                <TableCell>${row.contribution}</TableCell>
              </TableRow>
            ))}
          {(!rows || rows.length == 0) && (
            <TableRow key='notFound'>
              <TableCell colSpan={10} align='center'>
                No Data Found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
